/**
 * Task #446 — Avviso "modalità ferie" mostrato su TUTTE le pagine pubbliche.
 * Legge lo stato calcolato dal server (/api/public/vacation-config): se la
 * modalità non è attiva (flag off o data di fine superata) non renderizza nulla.
 */
import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "wouter";
import { Gift } from "lucide-react";

export interface VacationConfig {
  active: boolean;
  endDate?: string | null;
  couponValue?: number;
  bannerTitle?: string;
  bannerMessage?: string;
  bannerCta?: string;
  segments?: Record<string, { enabled: boolean; title: string; condition: string }>;
}

export function useVacationConfig() {
  return useQuery<VacationConfig>({
    queryKey: ["/api/public/vacation-config"],
    staleTime: 5 * 60 * 1000,
  });
}

export function VacationBanner() {
  const { data } = useVacationConfig();
  const [location] = useLocation();

  // Sulla pagina di richiesta/grazie il banner è ridondante.
  if (!data?.active || location.startsWith("/ferie")) return null;

  return (
    <div
      className="bg-[#333D29] text-white"
      role="region"
      aria-label="Avviso chiusura per ferie"
      data-testid="banner-vacation"
    >
      <div className="container mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left">
        <p className="text-sm leading-snug">
          <span className="font-semibold uppercase tracking-wider mr-2">{data.bannerTitle}</span>
          <span className="opacity-90">{data.bannerMessage}</span>
        </p>
        <Link
          href="/ferie"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-sm bg-[#e0ae26] px-4 py-2 text-sm font-semibold text-[#262c2d] hover:brightness-105 focus:outline-none focus:ring-2 focus:ring-white"
          data-testid="link-vacation-coupon"
        >
          <Gift className="h-4 w-4" aria-hidden="true" />
          {data.bannerCta}
        </Link>
      </div>
    </div>
  );
}
